import { createContext } from "react";
import type { AbilityContextType } from "../types/types";

export const AbilityContext = createContext<AbilityContextType | undefined>(
  undefined,
);
